export enum OwnershipPermissionType {
  Owner = "Owner" as any,
  Write = "Write" as any,
  Read = "Read" as any,
  None = "None" as any,
}
